document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.quickadd_variants').forEach((button) => {
        button.addEventListener('click', function () {
            console.log('Quick Add button clicked');
            const productCard = this.closest('.card-wrapper'); // Gebruik '.card-wrapper' als de product container
            const sizeWrapper = productCard.querySelector('.size-wrapper');
            sizeWrapper.classList.toggle('active');
        });
    });
});
